import { isZigzag } from '@common/device-manager';
import { Log } from '@common/log-manager';
import { getFirstContentfulPaintTime } from '../first-contentful-paint/first-contentful-paint-core';

import { createConnectionTypeLabel } from '../utils/network-connection';
import { getPerformanceNow } from '../utils/time';

export type TTISender = (log: Log) => void | Promise<void>;

export interface LogTTIMetricsParams {
  payload: Omit<Log, 'category'> | (() => Omit<Log, 'category'>);
  options?: {
    duration?: {
      min?: number;
      max?: number;
    };
  };
  sender: TTISender;
}

const WEB_END_LABEL = 'web_end';

export const logTTIMetrics = (params: LogTTIMetricsParams) => {
  const { min = 0, max = Infinity } = params.options?.duration ?? {};

  try {
    const duration = getPerformanceNow();
    const timestamp = Date.now();

    if (!duration || duration === 0) {
      return;
    }

    if (duration < min) {
      return;
    }

    if (max < duration) {
      return;
    }

    // NOTE: wifi, cellular 여부
    const connectionType = createConnectionTypeLabel();
    const payload = typeof params.payload === 'function' ? params.payload() : params.payload;

    if (payload.navigation_sub?.page_url) {
      const pageUrl = new URL(payload.navigation_sub.page_url);
      const externalSearchParams = new URLSearchParams(window.location.search);

      externalSearchParams.forEach((value, name) => {
        pageUrl.searchParams.set(name, value);
      });

      payload.navigation_sub.page_url = pageUrl.href;
    }

    const fcp = getFirstContentfulPaintTime();
    const metrics = fcp ? { fcp } : {};

    params.sender({
      ...payload,
      category: 'tti',
      data: {
        platform_type: isZigzag() ? 'App' : 'Web',
        connection_type: connectionType,
        metrics,
        ...payload?.data,
        tti: {
          category: 'scene_tti',
          label: WEB_END_LABEL,
          ...payload?.data?.tti,
          timestamp,
          duration,
        },
      },
    });
  } catch (e) {
    console.warn(e);
  }
};
